import React from "react";
import { uri } from "../../../help/Api";
import { useEffect } from "react";
import BackdropScI from "../../../services/BackdropScI";
import useFetchURL from "../../../components/Hooks/useFetchURL";
import SubscriptionRenew from "./subscription-renew-settings";
import { sto } from "../../../Context/InshData";

export default function SubscriptionRenewCon() {
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = "/Foundation"
  } else {
    Urls = `/Foundation?db_name=${sto?.db_name}`
  }
  const url = uri + Urls;

  const { data, fetching, fetchURL } = useFetchURL({
    ...{
      url,
    },
  });

  useEffect(() => {
    console.log("data  is", data);
  });

  if (fetching || !data) return <BackdropScI />;
  return (
    <SubscriptionRenew
      {...{
        data,
        fetchURL,
      }}
    />
  );
}
